<template>
  <range
    :label="$t('edit.sidebar.font_size')"
    min="0"
    max="10"
    step="0.1"
    :value="value()"
    :change="onChange"
    :move="onMove"
  ></range>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Range from '../../../../general/Range.vue';

const defaultValue = 1;

export default {
  props: [
    'item',
    'general',
  ],
  components: {
    Range,
  },
  methods: {
    value() {
      let value = defaultValue;
      const style = this.stepStyle(this.item);

      if (!style || !style.fontSize) {
        return value;
      }

      if (style.fontSize.includes('px')) {
        const px = parseFloat(style.fontSize.replace('px', ''));
        value = (px / 10);

        return value.toFixed(1).toString();
      }

      return style.fontSize.replace('rem', '');
    },
    onChange(value) {
      if (this.general) {
        return this.quizUpdateStyle({
          item: this.item,
          rule: 'fontSize',
          value: `${value}rem`,
        });
      }

      return this.stepUpdateStyle({
        item: this.item,
        rule: 'fontSize',
        value: `${value}rem`,
      });
    },
    onMove(value) {
      if (this.general) {
        return this.quizPreviewStyleChange({
          item: this.item,
          rule: 'fontSize',
          value: `${value}rem`,
        });
      }

      return this.stepPreviewStyleChange({
        item: this.item,
        rule: 'fontSize',
        value: `${value}rem`,
      });
    },
    ...mapActions([
      'quizUpdateStyle',
      'quizPreviewStyleChange',
      'stepUpdateStyle',
      'stepPreviewStyleChange',
    ]),
  },
  computed: mapGetters({
    stepStyle: 'stepStyle',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** FontSize.vue?299ed168
 **/